'use client';
import { jsx } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import '../icons/ActivityIcon.js';
import '../icons/ArrowDownIcon.js';
import '../icons/ArrowDownRightCircleIcon.js';
import '../icons/ArrowLeftAlignIcon.js';
import '../icons/ArrowLeftIcon.js';
import '../icons/ArrowRightAlignIcon.js';
import '../icons/ArrowRightIcon.js';
import '../icons/ArrowSwitchIcon.js';
import '../icons/ArrowUpIcon.js';
import '../icons/ArrowUpRightCircleIcon.js';
import '../icons/ArrowsAngleExpandIcon.js';
import '../icons/BankIcon.js';
import 'lodash';
import 'styled-components';
import CheckIcon from '../icons/CheckIcon.js';
import '../icons/ChevronDownIcon.js';
import '../icons/ChevronRightIcon.js';
import '../icons/ChevronUpIcon.js';
import CopyIcon from '../icons/CopyIcon.js';
import '../icons/CrossIcon.js';
import '../icons/DaiIcon.js';
import '../icons/DangerIcon.js';
import '../icons/DownSortIcon.js';
import '../icons/ExclamationTriangleIcon.js';
import '../icons/ExpandKpiIcon.js';
import '../icons/EyeIcon.js';
import '../icons/EyeSlashIcon.js';
import '../icons/Grid1x2Icon.js';
import '../icons/InfoCircleIcon.js';
import '../icons/ListIcon.js';
import '../icons/LockIcon.js';
import '../icons/MediumIcon.js';
import '../icons/MoonIcon.js';
import '../icons/PiggyBankIcon.js';
import '../icons/QuestionMarkCircleIcon.js';
import '../icons/ShieldIcon.js';
import '../icons/SunIcon.js';
import '../icons/UpSortIcon.js';
import '../icons/XIcon.js';
import '../../theme/GlobalStyle.js';
import 'react-helmet-async';
import ThemedComponentWrapper from '../../theme/ThemedComponentWrapper.js';

function CopyButton({ value, size, ...rest }) {
    const [copied, setCopied] = useState(false);
    const handleCopyClick = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (navigator.clipboard) {
            navigator.clipboard.writeText(value).then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 10000);
            });
        }
    }, [value]);
    return (jsx(ThemedComponentWrapper, { onClick: handleCopyClick, ...rest, name: "copyButton", children: copied ? jsx(CheckIcon, { size: size }) : jsx(CopyIcon, { size: size }) }));
}

export { CopyButton as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29weUJ1dHRvbi5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvYXRvbXMvQ29weUJ1dHRvbi50c3giXSwic291cmNlc0NvbnRlbnQiOlsiJ3VzZSBjbGllbnQnO1xuXG5pbXBvcnQgeyB1c2VDYWxsYmFjaywgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBDb3B5SWNvbiwgQ2hlY2tJY29uIH0gZnJvbSAnQGljb25zJztcbmltcG9ydCB7IFRoZW1lZENvbXBvbmVudFdyYXBwZXIgfSBmcm9tICdAdGhlbWUnO1xuaW1wb3J0IHsgU2l6ZSB9IGZyb20gJy4uLy4uL3RoZW1lL3R5cGVzJztcbmltcG9ydCB7IFRoZW1lZENvbXBvbmVudFdyYXBwZXJQcm9wcyB9IGZyb20gJy4uLy4uL3RoZW1lL1RoZW1lZENvbXBvbmVudFdyYXBwZXInO1xuXG5pbnRlcmZhY2UgQ29weUJ1dHRvblByb3BzXG4gIGV4dGVuZHMgT21pdDxUaGVtZWRDb21wb25lbnRXcmFwcGVyUHJvcHMsICdzaXplJyB8ICduYW1lJz4ge1xuICB2YWx1ZTogc3RyaW5nO1xuICBzaXplPzogU2l6ZSB8IHN0cmluZyB8IG51bWJlcjtcbn1cblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gQ29weUJ1dHRvbih7IHZhbHVlLCBzaXplLCAuLi5yZXN0IH06IENvcHlCdXR0b25Qcm9wcykge1xuICBjb25zdCBbY29waWVkLCBzZXRDb3BpZWRdID0gdXNlU3RhdGU8Ym9vbGVhbj4oZmFsc2UpO1xuXG4gIGNvbnN0IGhhbmRsZUNvcHlDbGljayA9IHVzZUNhbGxiYWNrKFxuICAgIChlOiBSZWFjdC5Nb3VzZUV2ZW50PEhUTUxEaXZFbGVtZW50PikgPT4ge1xuICAgICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgICAgZS5zdG9wUHJvcGFnYXRpb24oKTtcblxuICAgICAgaWYgKG5hdmlnYXRvci5jbGlwYm9hcmQpIHtcbiAgICAgICAgbmF2aWdhdG9yLmNsaXBib2FyZC53cml0ZVRleHQodmFsdWUpLnRoZW4oKCkgPT4ge1xuICAgICAgICAgIHNldENvcGllZCh0cnVlKTtcblxuICAgICAgICAgIHNldFRpbWVvdXQoKCkgPT4ge1xuICAgICAgICAgICAgc2V0Q29waWVkKGZhbHNlKTtcbiAgICAgICAgICB9LCAxMDAwMCk7XG4gICAgICAgIH0pO1xuICAgICAgfVxuICAgIH0sXG4gICAgW3ZhbHVlXVxuICApO1xuXG4gIHJldHVybiAoXG4gICAgPFRoZW1lZENvbXBvbmVudFdyYXBwZXJcbiAgICAgIG9uQ2xpY2s9e2hhbmRsZUNvcHlDbGlja31cbiAgICAgIHsuLi5yZXN0fVxuICAgICAgbmFtZT1cImNvcHlCdXR0b25cIj5cbiAgICAgIHtjb3BpZWQgPyA8Q2hlY2tJY29uIHNpemU9e3NpemV9IC8+IDogPENvcHlJY29uIHNpemU9e3NpemV9IC8+fVxuICAgIDwvVGhlbWVkQ29tcG9uZW50V3JhcHBlcj5cbiAgKTtcbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBY3dCOztBQUd0Qjs7O0FBS0k7Ozs7OztBQU9FOztBQUVKO0FBSUY7QUFRRjs7In0=
